import React, {useCallback, useEffect} from 'react';

import {
   cityObservable$,
   stateInput$,
   zipInput$,
} from 'ui/util/rxjs/observables';
import {getCitySuggestions} from 'app/employer/services/suggestions/city';
import ReduxInputAutosuggest from './ReduxInputAutosuggest';

const ReduxCityInputAutosuggest = (props) => {
   useEffect(() => {
      const subscription = cityObservable$.subscribe((city) => {
         props.input.onChange(city);
      });
      return () => {
         subscription.unsubscribe();
      };
   }, []);

   const handleSelect = useCallback(({ value, state, zip }) => {
      props.input.onChange(value);
      stateInput$.next(state);
      zipInput$.next(zip);
   }, [props.input.onChange]);

   return (
      <ReduxInputAutosuggest
         {...props}
         getSuggestions={getCitySuggestions}
         handleSelect={handleSelect}
         className={`form-control ${ props.className ? props.className : '' }`}
      />
   );
};

export default ReduxCityInputAutosuggest;
